import React, { useState, useCallback, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { renderRoutes } from 'react-router-config';
import ReactGA from 'react-ga';
import api from '@src/utils/api';
import 'semantic-ui-css/semantic.css';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';        // ← usamos withRouter em vez de useHistory
import ScrollToTop from '@src/components/ScrollToTop';
import SessionTimeoutModal from '@src/components/SessionTimeoutModal/SessionTimeoutModal';
import '@src/containers/App/App.css';
import routes from '@src/routes';
import config from '@src/config';
import { preventCustomDomainAccess } from '@src/helpers/customDomainsHelper';
import useSessionTimeout from '@src/hooks/useSessionTimeout';
import APP_ROUTES from '@src/app_routes';
import { getUser } from '@src/redux/modules/auth';


ReactGA.initialize(config.googleAnalyticsId, {
  debug: !(process.env.REACT_APP_ENV === 'production'),
});

preventCustomDomainAccess();

const { modalTimeout } = config;

const App = ({ user, history }) => {
  const [showTimeoutModal, setShowTimeoutModal] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const timeoutRef = useRef(null);

  const handleLogout = useCallback(async () => {
    clearTimeout(timeoutRef.current);
    setShowTimeoutModal(false);
    setIsRefreshing(false);
    try {
      await api.delete('/sessions');
    } finally {
      history.push(APP_ROUTES.home);
    }
  }, [history]);

  const handleTimeout = useCallback(() => {
    setShowTimeoutModal(true);
    timeoutRef.current = setTimeout(() => handleLogout(), modalTimeout);
  }, [handleLogout, modalTimeout]);

  const handleStayConnected = useCallback(async () => {
    clearTimeout(timeoutRef.current);
    setIsRefreshing(true);
    try {
      await api.post('/sessions/refresh');
      setShowTimeoutModal(false);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Session refresh failed:', error);
      handleLogout();
    } finally {
      setIsRefreshing(false);
    }
  }, [handleLogout]);

  useEffect(() => {
    return () => clearTimeout(timeoutRef.current);
  }, []);

  const onTimeout = useCallback(() => {
    if (user) handleTimeout();
  }, [user, handleTimeout]);

  useSessionTimeout(onTimeout);

  return (
    <>
      <ScrollToTop>
        {renderRoutes(routes)}
      </ScrollToTop>

      {user && (
        <SessionTimeoutModal
          show={showTimeoutModal}
          onStayConnected={handleStayConnected}
          onLogout={handleLogout}
          isLoading={isRefreshing}
        />
      )}
    </>
  );
};

App.propTypes = {
  user: PropTypes.object,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

App.defaultProps = {
  user: null,
};

const mapStateToProps = state => ({
  user: getUser(state),
});

export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./src/containers/App/App.js